import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { Icon } from "linkd-ui";
export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeWrapper',
  props: {
    iconName: {},
    colorType: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.css.notice_wrapper)
      }, [_createVNode(_unref(Icon), {
        name: props.iconName,
        class: _normalizeClass(_ctx.css[props.colorType]),
        fontClassName: "iconfont",
        size: "40px"
      }, null, 8, ["name", "class"]), _createElementVNode("div", {
        class: _normalizeClass(_ctx.css.text)
      }, [_renderSlot(_ctx.$slots, "default")], 2)], 2);
    };
  }
});